export interface RuntimeConfig {
  api_url: string;
  app_name: string;
}

let config: RuntimeConfig | null = null;

export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
  if (config) return config;

  try {
    const response = await fetch('/config.json');
    config = await response.json();
  } catch {
    config = {
      api_url: process.env.REACT_APP_API_URL || 'http://localhost:3000/api/v1',
      app_name: process.env.REACT_APP_NAME || 'CBS Support',
    };
  }

  return config!;
}

export function getRuntimeConfig(): RuntimeConfig {
  if (!config) {
    throw new Error('Runtime config not loaded. Call loadRuntimeConfig() first.');
  }
  return config;
}
